import { gql } from '@apollo/client'

const UPDATE_CHALLENGE_RELATIONS_DETAILS_MUTATION = gql`
  mutation updateChallengeRelationsDetails(
    $id: ID!
    $data: ChallengeRelationsDetailsInput!
  ) {
    updateChallengeRelationsDetails(id: $id, data: $data) {
      id
      type
      updatedAt

      updatedBy {
        id
        name
      }

      cuisineTypes {
        id
      }

      dishTypes {
        id
      }
    }
  }
`

export default UPDATE_CHALLENGE_RELATIONS_DETAILS_MUTATION
